import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Grid from '@mui/material/Grid';
import {digitsEnToFa} from 'persian-tools2';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import React from 'react';
import {makeStyles} from '@mui/styles';
import styles from '../../../../assets/jss/LogBook/gridTableStyle';
import {styled} from '@mui/material/styles';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';

const useStyles = makeStyles(styles);

const StickyTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    '@media print': {
      backgroundColor: '#FFFFFF !important',
      border: '1px solid #DADADA !important',
    },
    fontSize: '10px',
    backgroundColor: '#EBEBEB',
    // height: '60px',
    padding: '5px',
    border: '1.5px solid rgba(249, 250, 251, 1)',
    width: '55px',
    [theme.breakpoints.up(600)]: {
      fontSize: '16px',
    },
  },
  [`&.${tableCellClasses.body}`]: {
    '@media print': {
      backgroundColor: '#FFFFFF !important',
      border: '1px solid #DADADA !important',
    },
    backgroundColor: 'rgba(117, 60, 190, 0.1)',
    padding: '5px',
    width: '55px',
    border: 'none',
  },
}));

const StyledTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    '@media print': {
      backgroundColor: '#FFFFFF !important',
      border: '1px solid #DADADA !important',
    },
    fontSize: '10px',

    background: '#DAE7E7 !important',
    border: '1.5px solid rgba(249, 250, 251, 1)',
    color: '#3CC0C3',
    fontFamily: 'dana-bold',
    padding: '5px',
    width: '40px !important',
    [theme.breakpoints.up(600)]: {
      fontSize: '16px',
    },
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: 'center',
    height: 'auto',
    padding: '5px',
  },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
  '@media print': {
    backgroundColor: '#FFFFFF !important',
    border: '1px solid #DADADA !important',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#EBEBEB',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#EBEBEB',
  },
}));

export function HeaderComponent({finalData, dataFromPdf, gridHeaderDate}) {
  const classes = useStyles();
  const hours = [
    digitsEnToFa('00-06'),
    digitsEnToFa('06-09'),
    digitsEnToFa('09-12'),
    digitsEnToFa('12-15'),
    digitsEnToFa('15-18'),
    digitsEnToFa('18-21'),
    digitsEnToFa('21-24'),
  ];
  return (
    <TableHead>
      <TableRow>
        <StickyTableCell
          style={{maxHeight: '45px', textAlign: 'center'}}
          colSpan={12}>
          {dataFromPdf ? (
            gridHeaderDate?.component
          ) : (
            <span className={classes.textHour} style={{color: '#3CC0C3'}}>
              ساعت
            </span>
          )}
        </StickyTableCell>
      </TableRow>
      <TableRow>
        <StickyTableCell>
          <span style={{color: '#3CC0C3'}} className={classes.textWeek}>
            روز
          </span>
        </StickyTableCell>
        {hours.map((hour) => (
          <StyledTableCell align='center' numeric>
            <span>{hour}</span>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export function CellData({dayRow}) {
  const classes = useStyles();
  const color = ['#3BBA4C', '#FEB140', '#D81D5D'];
  const rows = [];
  for (let i = 1; i < 8; i++) {
    rows.push(
      <StyledTableCell numeric className={classes.cell}>
        {dayRow[i].map((hourCell, index) => {
          return (
            <Grid container justifyContent='center' key={index}>
              <Grid item xs={12}>
                <span className={classes.glucoseText}>
                  {digitsEnToFa(hourCell[0])}
                </span>
                <FiberManualRecordIcon
                  style={{
                    fontSize: '5px',
                    color: color[hourCell[1]],
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
      </StyledTableCell>
    );
  }
  return rows;
}

const CreateGridCells = (finalData) => {
  const classes = useStyles();
  return finalData?.data?.map((dayRow) => {
    return (
      <StyledTableRow key={dayRow.id}>
        <StickyTableCell numeric className={classes.cell}>
          <span className={classes.textWeek}>
            {/*hours*/}
            {dayRow[0]}
          </span>
        </StickyTableCell>
        <CellData dayRow={dayRow} />
      </StyledTableRow>
    );
  });
};

export default function TableComponent({
  finalData,
  dataFromPdf,
  gridHeaderDate,
  pdfGridData,
}) {
  return (
    <Table>
      <HeaderComponent
        finalData={finalData}
        dataFromPdf={dataFromPdf}
        gridHeaderDate={gridHeaderDate}
      />
      <TableBody>
        {pdfGridData
          ? CreateGridCells(pdfGridData)
          : CreateGridCells(finalData)}
      </TableBody>
    </Table>
  );
}
